.wrapper {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 15;
  background: #fffbf2;
  overflow-y: scroll;
}

.container {
  max-width: 450px;
  width: 100%;
  padding: 0 20px 38px 20px;
  margin: 0 auto;
}

.title {
  padding: 16px 0;
  color: #221e1a;
  text-align: center;
  font-size: 26px;
  font-weight: 700;
  line-height: 32px;
  letter-spacing: -0.4px;

  span {
    color: #29a073;
  }
}

.card {
  border-radius: 16px;
  // 50 / 335 — room for the part of the cover that hangs above the card.
  padding-top: 14.925%;
}

.cover {
  position: relative;
  width: 100%;
  // 178 / 335 — the height of the cover block that sits inside the card.
  padding-top: 53.134%;
  background: #f2ede1;
  border-radius: 16px 16px 0 0;
}

// The artwork is taller than `.cover` and overflows upwards into the card padding.
.coverImg {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;

  img {
    display: block;
    width: 100%;
  }
}

.coverBadge {
  position: absolute;
  // 289 / 335, 39 / 178 and 50 / 335 of the cover block.
  left: 86.268%;
  top: 21.91%;
  width: 14.925%;
  height: auto;
}

.payment {
  background: #f2ede1;
  padding: 0 16px 30px 16px;
  border-radius: 0 0 16px 16px;

  // The shared payment modal carries 32px of top padding for the default PDF screen.
  // Here the block starts right under the price row, so drop it for this design only.
  :global(#paymentModal) {
    padding-top: 0;
  }
}

// Dark mode
:global body.dark {
  :local {
    .wrapper {
      background-color: #181716;
    }

    .title {
      color: #fffbf2;
    }

    .cover,
    .payment {
      background-color: #2a2928;
    }
  }
}
